import { StrictMode, lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { SharedMapView } from './components/SharedMapView.jsx'
import { ErrorBoundary } from './components/ErrorBoundary.jsx'

const WhiteboardPage = lazy(() =>
  import('./components/whiteboard/WhiteboardPage.jsx').then((m) => ({ default: m.WhiteboardPage }))
)

const shareMatch = window.location.pathname.match(/^\/share\/([a-f0-9-]+)$/i)
const isWhiteboard = window.location.pathname === '/whiteboard'

export function Root() {
  if (shareMatch) return <SharedMapView shareId={shareMatch[1]} />
  if (isWhiteboard) return (
    <Suspense fallback={<div className="fixed inset-0 bg-ctp-base" />}>
      <WhiteboardPage />
    </Suspense>
  )
  return <App />
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <Root />
    </ErrorBoundary>
  </StrictMode>,
)
